import React from 'react';
import { Grid, GridProps } from '@mui/material';
import { KFErrorScreen, KFLoader } from '@kf/ic2fx';
import { Ic2fxComponentType, Ic2fxErrorType } from 'models/enum';

export interface IRenderIc2fxComponent {
  componentType: Ic2fxComponentType;
  className?: string;
  sxProps?: GridProps;
  errorType?: Ic2fxErrorType;
  errorMessage?: string;
}

const Ic2fxComponentWrapper = ({
  componentType,
  className,
  sxProps,
  errorType,
  errorMessage,
}: IRenderIc2fxComponent) => {
  return (
    <Grid
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='70vh'
      data-testid='ic2fx-component'
      sx={{ padding: '4.75rem 1.25rem 0.938rem 1.25rem' }}
      {...sxProps}
    >
      {componentType === Ic2fxComponentType.loader && (
        <KFLoader className={className} />
      )}
      {componentType === Ic2fxComponentType.errorScreen && (
        <KFErrorScreen
          className={className}
          errorType={errorType ?? Ic2fxErrorType.forbidden}
          errorMessage={errorMessage}
        />
      )}
    </Grid>
  );
};

export default Ic2fxComponentWrapper;
